import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Choice from '@components/choice/Choice'

import { breakpoints } from '@utils/breakpoints'

const TEST_DATA = [
  { label: 'Item 1', value: 1 },
  { label: 'Item 2', value: 2 },
  { label: 'Item 3', value: 3 },
  { label: 'Item 4', value: 4 },
  { label: 'Item 5', value: 5 },
]

const FontsSection = () => {
  const [choice1, setChoice1] = React.useState(TEST_DATA[0])
  const [choice2, setChoice2] = React.useState(TEST_DATA[0])
  const [choice3, setChoice3] = React.useState(TEST_DATA[0])

  return (
    <Section>
      <SectionTitle>Choices</SectionTitle>

      <Container>
        <Choice data={TEST_DATA} onItemSelected={setChoice1} value={choice1} />
      </Container>

      <Container>
        <Choice data={TEST_DATA} onItemSelected={setChoice2} numColumns={2} value={choice2} />
      </Container>

      <Container>
        <Choice data={TEST_DATA.slice(0, 2)} onItemSelected={setChoice3} numColumns={2} value={choice3} />
      </Container>
    </Section>
  )
}

export default FontsSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;

  @media only screen and (width >= ${breakpoints.phone}px) {
    padding: 24px 48px;
  }
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const Container = styled(View)`
  margin: 16px 0;
`
